/**
 * Copyright 2025 Lumavec Group LLC
 *
 * All rights reserved. No part of this software may be used, copied, modified,
 * or distributed without explicit written permission. This software is provided
 * "as-is" without warranty of any kind, express or implied, including but not
 * limited to warranties of merchantability or fitness for a particular purpose.
 */

import { pgTable, text, serial, integer, timestamp, boolean } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";

// Images
export const images = pgTable("images", {
  id: serial("id").primaryKey(),
  contentId: integer("content_id"), // Optional reference to content
  prompt: text("prompt"), // Prompt used to generate the image
  modelId: text("model_id"), // Model used to generate the image
  imageData: text("image_data").notNull(), // Binary image data (base64 encoded for PostgreSQL)
  contentType: text("content_type").notNull(), // MIME type (e.g., image/jpeg, image/png)
  size: text("size"), // Size specification (e.g., "1024x1024")
  width: integer("width"), // Image width in pixels
  height: integer("height"), // Image height in pixels
  isThumbnail: boolean("is_thumbnail").default(false), // Whether this is a thumbnail image
  createdAt: timestamp("created_at").defaultNow(),
});

// Insert schemas
export const insertImageSchema = createInsertSchema(images);

// Types
export type Image = typeof images.$inferSelect;
export type InsertImage = Omit<Image, 'id' | 'createdAt'>; 